import { render, staticRenderFns } from "./CourseVideo.vue?vue&type=template&id=f25b647c&scoped=true&"
import script from "./CourseVideo.vue?vue&type=script&lang=js&"
export * from "./CourseVideo.vue?vue&type=script&lang=js&"
import style0 from "./CourseVideo.vue?vue&type=style&index=0&id=f25b647c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f25b647c",
  null
  
)

export default component.exports